@if (![3].includes(shopping_cart && shopping_cart.orderTypeId)) {
  <span>
    <h6 class="display-6 mb-0">{{ device.manufacturer }}</h6>
    <h3 [ngClass]="{ 'mb-0': !is_bp_device }">{{ device.model }}</h3>
    @if (is_bp_device) {
      <h4>{{ constructBusinessPurpose() }}</h4>
    }
  </span>
} @else {
  <h3 [ngClass]="{ 'mb-0': !is_bp_device }">{{ constructAssetTitle() }}</h3>
  @if (is_bp_device) {
    <h4>{{ constructBusinessPurpose() }}</h4>
  }
}

@if ([17].includes(shopping_cart && shopping_cart.orderTypeId) && device.description !== '') {
  <p class="mt-2">
    {{ device.description }}
  </p>
}
